import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import '../../index.css';
import IndexV3 from './indexV3';
import IndexV2 from './indexV2';

const LoginFlow = () => {
    if (process.env.REACT_APP_USE_NEW_LOGIN === 'true' || process.env.REACT_APP_USE_NEW_LOGIN === 'TRUE') {
        return <IndexV3 />;
    } else {
        return <IndexV2 />;
    }
};

export default LoginFlow;
